<template>
  <!-- 單頁式(所有題目都在同一頁面)的情況 -->
  <!-- :style="{ backgroundColor: $store.state.questM.questBackColor }" -->
  <!-- 白邊改成底色，此處的backgroudcolor取消改回白色 -->
  <v-card v-if="allQuesInOnePage" class="px-9 py-5 text-center">
    <div
      v-for="(text, idx) in $store.state.questM.questTitle.split(/\r?\n/)"
      :key="'Answer_A' + idx"
      class="blod quest_title"
    >
      {{ text }}
    </div>
    <div
      v-for="(text, idx) in $store.state.questM.questDesc.split(/\r?\n/)"
      :key="'Answer_B' + idx"
      class="text-left quest_content"
    >
      {{ text }}
    </div>
    <img
      class="my-2"
      :width="'100%'"
      v-if="$store.state.questM.questStartPic !== null"
      v-bind:src="$store.state.server + $store.state.questM.questStartPic"
      style="max-width: 100%; align: center"
    />
    <div
      v-for="(text, idx) in $store.state.questM.questAnnounce.split(/\r?\n/)"
      :key="'Answer_C' + idx"
      class="text-left quest_content"
    >
      {{ text }}
    </div>
    <v-divider class="mb-3"></v-divider>
    <v-form ref="form" v-model="valid" :lazy-validation="false">
      <Ques
        v-for="(ques, idx) in $store.state.questD"
        :key="'Answer_D' + idx"
        class="mb-4"
        :ques="ques"
      />
      <v-btn
        color="primary"
        rounded
        :width="'100%'"
        :height="50"
        class="my-3"
        @click="submit1()"
      >
        填寫完成
      </v-btn>
    </v-form>
  </v-card>
  <!-- 如果是多頁式一題(下一題需換頁)的情況 -->
  <!-- class="px-9 py-5 text-center my-5" -->
  <!-- 增加白邊 -->
  <!-- :style="{ backgroundColor: $store.state.questM.questBackColor }" -->
  <!-- 白邊改成底色，此處的backgroudcolor取消改回白色 -->
  <v-card v-else class="px-5 px-sm-9 py-5 text-center my-5" width="100%" height="100%">
    <!-- 歡迎頁面 -->
    <template v-if="showQuesSerial === 0">
      <div
        v-for="(text, idx) in $store.state.questM.questTitle.split(/\r?\n/)"
        :key="'Answer_E' + idx"
        class="blod quest_title"
      >
        {{ text }}
      </div>
      <div
        v-for="(text, idx) in $store.state.questM.questDesc.split(/\r?\n/)"
        :key="'Answer_F' + idx"
        class="text-left quest_content"
      >
        {{ text }}
      </div>
      <!-- 拿掉:width="'100%'" 圖片過大問題 -->
      <!-- <div style="max-width:650px; max-height:400px;"> -->
      <img
        v-if="$store.state.questM.questStartPic !== null"
        v-bind:src="$store.state.server + $store.state.questM.questStartPic"
        style="max-width: 100%; "
      />
      <!-- </div> -->
      <div
        v-for="(text, idx) in $store.state.questM.questAnnounce.split(/\r?\n/)"
        :key="'Answer_G' + idx"
        class="text-left quest_content"
      >
        {{ text }}
      </div>
      <!-- 加入首頁開始按鈕 -->
      <div class="text-center">
        <v-btn
          color="primary"
          @click="onNextBtnClick()"
          style="color: #000; width: 100%; align: center"
        >
          開始填寫
        </v-btn>
      </div>
    </template>
    <!-- [Debug] -->
    <!-- showQuesSerial: {{ showQuesSerial }} <br />
    length: {{ $store.state.questD.length }} <br />
    activePreviousQuesBtn: {{ activePreviousQuesBtn }} <br /> -->

    <!-- adjust button's position of commit page -->
    <div
      v-if="showQuesSerial === $store.state.questD.length + 1"
      style="height: 40px"
    ></div>

    <!-- colum class for button position RWD -->
    <v-row
      justify="center"
      align="center"
      class="answer_row column"
      v-if="showQuesSerial != 0"
    >
      <!-- 上一題按鈕 -->
      <!--改掉 <v-col cols="1"> -->
      <!-- 取消首頁上頁按鈕 -->
      <div class="text-center">
        <v-btn
          color="primary"
          fab
          dark
          @click="onPreviousBtnClick()"
          :disabled="!activePreviousQuesBtn"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <!-- 增加flex顯示item垂直置中 -->
      <!-- colum class for button position RWD -->
      <v-col style="display: flex; justify-content: center; flex-flow: column">
        <!-- 題目 -->
        <v-form
          :lazy-validation="false"
          v-for="(ques, idx) in $store.state.questD"
          :key="'Answer_H' + idx"
          :ref="'form' + ques.serial"
          v-model="ques.valid"
          v-show="showQuesSerial === ques.serial"
          class=""
        >
          <!-- add title at each question page -->
          <div
            v-for="(text, idx) in $store.state.questM.questTitle.split(/\r?\n/)"
            :key="'Answer_E' + idx"
            class="blod quest_title"
          >
            {{ text }}
          </div>

          <!-- test_serial -->
          <!-- {{ ques.serial }} (only for test) -->
          <Ques :ques="ques" />

          <div class="v-label text-right serial">
            第{{ ques.serial }}題，共{{ $store.state.questD.length }}題
          </div>
        </v-form>
        <!-- 送出按鈕 -->
        <v-btn
          color="primary"
          rounded
          :width="'100%'"
          :height="50"
          class="my-3"
          @click="submit()"
          v-show="showQuesSerial === $store.state.questD.length + 1"
        >
          填寫完成
        </v-btn>
      </v-col>
      <!-- 下一題按鈕 -->
      <!--拿掉 <v-col cols="1"> -->
      <div class="text-center">
        <v-btn
          color="primary"
          fab
          dark
          @click="onNextBtnClick()"
          :disabled="!activeNextQuesBtn"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-row>
  </v-card>
</template>

<script>
import Ques from '../components/QuesRouter'
export default {
  created() {
    // [Debug]
    // window.console.log(this.$store.state.questM)
    if (this.$store.state.questD) {
      this.$store.state.questD.forEach((ques) => {
        ques.valid = false
      })
    }
  },
  components: {
    Ques,
  },
  computed: {
    haveTransUrl() {
      let questTransUrl = this.$store.state.questM.questTransUrl
      return questTransUrl != null && questTransUrl.length > 0
    },
    haveThankPic() {
      let qusetThankPic = this.$store.state.questM.qusetThankPic
      return (
        qusetThankPic != null &&
        qusetThankPic.length > 0 &&
        !qusetThankPic.endsWith('img/0/default_thx.jpg')
      )
    },
    // 上一題按鈕是否可按
    activePreviousQuesBtn() {
      // 歡迎畫面時不可按
      return !(this.showQuesSerial === 0)
    },
    // 下一題按鈕是否可按
    activeNextQuesBtn() {
      // 最後一題時不可按
      return !(this.showQuesSerial === this.$store.state.questD.length + 1)
    },
    // 是否為單頁式
    allQuesInOnePage() {
      return this.$store.state.questM.pageType === '10'
    },
    // 歡迎圖片
    picture() {
      let storePic = this.$store.state.questM.qusetStartPic
      if (storePic !== null && storePic.length > 0) {
        return this.$store.state.server + storePic
      } else {
        return this.$store.state.server + 'img/0/default_start.jpg'
      }
    },
  },
  data() {
    return {
      showQuesSerial: 0,
      valid: true,
      pathRoute: [],
      skipGroupArray: [],
    }
  },
  methods: {
    pushPage(pageName) {
      this.$router.push({
        name: pageName,
        query: { questSysId: this.$store.state.questM.questSysId },
      })
    },
    submit1() {
      // 表單驗證
      let validated = this.$refs.form.validate()
      if (!validated) {
        alert('表單驗證失敗')
        return false
      }
      this.submit()
    },
    //上一頁，取最後一個pathRoute的item，然後刪除此item
    onPreviousBtnClick() {
      // 如果不可按就不動作
      if (!this.activePreviousQuesBtn) return

      let previousPage = this.pathRoute[this.pathRoute.length - 1] //latest item of pathRoute
      this.pathRoute.pop() //delete latest item of pathRoute
      window.console.log(`pathRoute.pop() : ${this.pathRoute}`)
      this.showQuesSerial = previousPage
      window.console.log(`Back to showQuesSerial : ${this.showQuesSerial}`)
    },
    onNextBtnClick() {
      // 如果不可按就不動作
      if (!this.activeNextQuesBtn) return
      // 是否有驗證的表單，如果有就進行驗證
      let form = this.$refs['form' + this.showQuesSerial]
      if (form) {
        // 這個方法抓到的 form 是 array，所以 form[0] 驗證通過才下一題
        if (form[0].validate()) {
          this.pathRoute.push(this.showQuesSerial) //record pathRoute
          window.console.log(`show pathRoute : ${this.pathRoute}`)

          let currentCol = this.showQuesSerial - 1 //從0起算
          let questD = this.$store.state.questD //從store取用questD
          let value = questD[currentCol].value //目前選取的item
          if (questD[currentCol].skipItem && questD[currentCol].nextCol[value]) {
            //有開啟接題功能 && item有接題設定
            //有接題

            for (let index = 0; index < questD.length; index++) {
              const element = questD[index]
              if (questD[currentCol].nextCol[value] === element.enName) {
                this.showQuesSerial = element.serial
                if (questD[currentCol].skipGroup) {
                  //是否有群組接題
                  questD[currentCol].nextCol.forEach((element) => {
                    if (element) {
                      for (let index2 = 0; index2 < questD.length; index2++) {
                        //比對題號
                        if (element === questD[index2].enName)
                          this.skipGroupArray.push(questD[index2].serial)
                      }
                    }
                  }) //需跳過的題目加入陣列
                  this.skipGroupArray = [...new Set(this.skipGroupArray)];//取出沒重複的題號
                  this.skipGroupArray.sort() //整理陣列順序
                  window.console.log(this.skipGroupArray)
                }
                window.console.log(`Skip to showQuesSerial : ${this.showQuesSerial}`)
                break
              }
              //window.console.log(`index : ${index}`)
            }
          } else {
            //無接題
            this.showQuesSerial++
            if (this.skipGroupArray.length > 0) {
              this.skipGroupArray.forEach((element) => {
                if (this.showQuesSerial === element) this.showQuesSerial++
              })
            }//跳過接題群組的成員
            window.console.log(`showQuesSerial : ${this.showQuesSerial}`)
          }
          // this.showQuesSerial += 2
          //window.console.log(`questD : ${this.$store.state.questD[this.showQuesSerial-1].enName}`)
        }
      } else {
        //首頁至第一題
        this.pathRoute.push(this.showQuesSerial) //record pathRoute
        window.console.log(`show pathRoute : ${this.pathRoute}`)
        this.showQuesSerial++
        window.console.log(`first to showQuesSerial : ${this.showQuesSerial}`)
      }
    },
    async submit() {
      // Collecting formData
      let fd = new FormData()
      fd.append('questSysId', this.$store.state.questM.questSysId)
      // 根據是否有 userToken，決定要不要將 Token 設置到 Header 的 Authorization
      let userToken = this.$store.state.userToken
      if (userToken && userToken.length > 0) fd.append('userToken', userToken)

      let nullCheck = 0
      this.$store.state.questD.forEach((q) => {
        if (q.value != null) nullCheck += 1
        else nullCheck += 0

        if (q.questItemType === 'file') {
          //夾帶檔案的題型
          if (q.file != undefined) nullCheck += 1
          else nullCheck += 0
        }

        if (q.questItemType === 'matrix') {
          //陣列題型
          q.subQues.forEach((qs) => {
            if (qs.value != null) nullCheck += 1
            else nullCheck += 0
          })
        }
      })
      try {
        if (nullCheck === 0) {
          this.showQuesSerial = 0
          this.pathRoute = []
          throw new Error(res.data.error)
        } else {
          this.$store.state.questD.forEach((q) => {
            // 蒐集檔案上傳題回答結果
            if (q.file !== null && q.file != undefined) {
              fd.append(q.rowId, q.file)
            }
            // 蒐集一般題型回答結果
            if (q.value !== null && q.value != undefined) {
              fd.append(q.rowId, q.value)
            }
            // 蒐集矩陣題小題回答結果
            if (q.subQues !== null && q.subQues !== undefined) {
              q.subQues.forEach((qq) => {
                if (qq.value !== null) fd.append(qq.rowId, qq.value)
              })
            }
          })

          // 提交問卷
          this.pushPage('Loading')
          try {
            let res = await this.axios({
              method: 'post',
              url: this.$store.state.api + '/User/submit',
              // url: '/user/api/User/submit',
              data: fd,
            })
            console.log(`resultCode：${res.data.resultCode}`)
            switch (res.data.resultCode) {
              case '01': // 發生錯誤
                throw new Error(res.data.error)
                break
              case '99': // 已額滿
                this.pushPage('Fulled')
                break
              case '98': // 指定檢核重複，目前當一般錯誤處理
                throw new Error(res.data.error)
                break
              case '97': // 商業獅會員重複填寫問卷
                this.$store.state.errMessage = res.data.error.toString()
                this.pushPage('ErrorPage')
                //throw new Error(res.data.error)
                break
              default:
                // 將問卷狀態設置為完成
                this.$store.commit('setFinish')

                // window.console.log('server' + server)
                // window.console.log('this.haveTransUrl' + this.haveTransUrl)
                // window.console.log('this.haveThankPic' + this.haveThankPic)
                // window.console.log(
                //   'this.$store.state.questM.questTransUrl:' +
                //     this.$store.state.questM.questTransUrl
                // )
                // 如果沒有圖片、有感謝頁連結的話就直接轉出去
                if (this.haveTransUrl && !this.haveThankPic) {
                  window.location.href = this.$store.state.questM.questTransUrl
                  return
                }
                this.pushPage('Thank')
            }
          } catch (err) {
            this.$store.state.errMessage = ';提交問卷時發生問題：' + err.toString()
            this.pushPage('ErrorPage')
          }
        }
      } catch (error) {
        alert('不得提交空白問卷')
        this.pushPage('Answer')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
//改成對齊top
// .answer_row {
//   height: 100%;
// }

// .title{
//   display: flex;
//   flex-flow: column;
// }

.serial {
  position: relative;
  top: 25px;
  right: 15px;
}
</style>
